module.exports = __webpack_public_path__ + "static/media/Resource3.28f2a3af.webp";